import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contact",
  "use": "icon-contact-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-contact\"><path d=\"M12.5 6H10V3.5A1.5 1.5 0 0 0 8.5 2h-5A1.5 1.5 0 0 0 2 3.5v3A1.5 1.5 0 0 0 3.5 8H4v2.5l2-1.875V10.5A1.5 1.5 0 0 0 7.5 12h1.833L12 14.5V12h.5a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 12.5 6M6.027 7.229l-.044.041L5 8.192V7H3.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V6H7.5c-.735 0-1.345.53-1.473 1.229M13 10.5a.5.5 0 0 1-.5.5H11v1.192l-.983-.921L9.729 11H7.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol